import { PlayerOrNone } from '../Player';
import { GameStateWithTable } from './GameStateWithTable';
export class PlayerOrNoneGameStateWithTable extends GameStateWithTable {
    getPlayerCoordsAndContent() {
        return this
            .getCoordsAndContents()
            .filter((value) => {
            return value.content.isPlayer();
        })
            .map((value) => {
            return {
                coord: value.coord,
                content: value.content,
            };
        });
    }
    isEmptyAt(coord) {
        return this.hasPieceAt(coord, PlayerOrNone.NONE);
    }
}
